import { render, staticRenderFns } from "./PermissionGrid.vue?vue&type=template&id=aa732420&scoped=true"
import script from "./PermissionGrid.vue?vue&type=script&lang=js"
export * from "./PermissionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa732420",
  null
  
)

export default component.exports